import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SupervisorAccountIcon(props: IconProps) {
    return <Icon {...props} iconKey={"supervisor_account"}/>
}
